require('es6-object-assign').polyfill();
import { createApp } from 'vue';
import App from './App.vue'
import vueSmoothScroll from 'vue3-smooth-scroll'

const app = createApp(App);

app.config.productionTip = false;
app.use(vueSmoothScroll, { updateHistory: false });
app.mount('#app');